import React,{ Component } from 'react';
import { Container, Row, Col, Button, Form, Table, Input } from 'react-bootstrap';
import { Offline, Online } from "react-detect-offline";
import FormSelect from "../../components/FormField/FormSelect";


export default class TableColumnRow extends Component {
    constructor(props){
    	super(props);
    	this.state = {
          text: 'Sync my data'
      };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            this.setState({ text: 'Sync my data' });
        }
    }

    mountTableHeaders(rows) {
      return (
        <>
          <th key="OutputColumnName">Output Column Name</th>
          <th key="InputColumnName">Input Column Name</th>
        </>
      )
    }

    mountTableBody(rows) {
        let body = [];
        for (var i = 1; i < rows.length; i++) {
            
            body.push(
                <tr key={rows.length + i}>
                  {this.innerTableContent(rows[i], i)}
                </tr>
            );
        }

        return body;
    }

    innerTableContent(row, count) {
      const { headers } = this.props;
      console.log('innerTableContent.headers',headers);
      return (
        <>
          <td key={row._id}>{row.title}</td>
          {/* <td key={row._id+"dropdown"}>{this.dropDownContent(row.name, count)}</td> */}
          <td key={row._id+"dropdown"}>
            <FormSelect
              className="forminput"
              placeholder="Select Column"
              optionList={headers}
              value={this.props.selectedReport}
              setFunc={this.handleHeaderChange.bind(this)}
              showLabel={false}
            />
            {/* <Input
                type="select"
                name={row.name}
                id={row.name}
                placeholder="Select Column"
                // value={this.props.selectedReport}
                onChange={this.handleHeaderChange.bind(this)}
              >
                <option value='default' key={0}>Select Option</option>
                {
                  headers.map((option, i) => <option value={option} key={i}>{option}</option>)
                }
              </Input> */}
          </td>
        </>
      )
    }

    dropDownContent(name, count) {
      const { headers } = this.props;
      console.log('dropDownContent.headers',headers);
      const that = this;
        return (
          <>
            <FormSelect
              className="forminput"
              placeholder="Select Column"
              optionList={headers}
              value={this.props.selectedReport}
              setFunc={this.handleHeaderChange.bind(this)}
              showLabel={false}
            />
            {/* <Input
                type="select"
                name={name}
                id={name}
                placeholder="Select Column"
                // value={this.props.selectedReport}
                onChange={this.handleHeaderChange.bind(this)}
              >
                <option value='default' key={0}>Select Option</option>
                {
                  headers.map((option, i) => <option value={option} key={i}>{option}</option>)
                }
            </Input> */}
          </>
        )
    }

    handleHeaderChange(e) {
      const { target: { value, name } } = e;
      const { columnsRowsMapping, setColumnsRowsMapping } = this.props;
      
      const obj = {};
      obj[name] = value;

      let mappingColumns = columnsRowsMapping || [];
      mappingColumns.push(obj);
      
    }

    syncData() {
        this.setState({ text: 'Data sync successfull!! '});
    }

    renderButtons() {
        const { text } = this.state;

        return (
          <Row
            key='render-buttons-form-group'
          >
              <Col>
                <Offline>
                   You must be online to sync your data! Active your internet connection.
                </Offline>
              </Col>
          </Row>
        );
    }

    render() {
      const { rows } = this.props;
      if (rows && rows.length > 0) {
        return(
          <Container>
            {this.renderButtons()}
            <Table hover responsive>
              <thead>
                <tr>
                  {this.mountTableHeaders(rows)}
                </tr>
              </thead>
              <tbody>
                {this.mountTableBody(rows)}
              </tbody>
            </Table>
          </Container>
        );
      }

      return null;
    }
}
